import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FaQrcode, FaArrowRight } from 'react-icons/fa';
import './QRLanding.css';

function QRLanding() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [showSplash, setShowSplash] = useState(false);
  const restaurantId = searchParams.get('restaurantId');

  useEffect(() => {
    // If restaurantId is present in URL, show splash screen
    if (restaurantId) {
      setShowSplash(true);
    }
  }, [restaurantId]);

  const handleEnterMenu = () => {
    if (restaurantId) {
      // New universal flow: customer always lands on /menu/:restaurantId first
      navigate(`/menu/${encodeURIComponent(restaurantId)}`);
    } else {
      navigate('/customer/menu');
    }
  };

  // If restaurantId is present, go to universal landing page.
  // (Keeps the overall flow consistent: QR -> landing -> View Menu)
  useEffect(() => {
    if (showSplash && restaurantId) {
      navigate(`/menu/${encodeURIComponent(restaurantId)}`);
    }
  }, [showSplash, restaurantId, navigate]);

  // Default landing page (no restaurantId)
  return (
    <div className="qr-landing">
      <div className="qr-landing-content">
        <div className="qr-icon-container">
          <FaQrcode className="qr-icon" />
        </div>
        <h1 className="qr-title">Welcome to MenuBazzar</h1>
        <p className="qr-subtitle">Scan the QR code on your table to view our digital menu</p>
        <div className="qr-image-placeholder">
          <div className="qr-code-simulator">
            <div className="qr-pattern"></div>
            <p className="qr-hint">QR Code</p>
          </div>
        </div>
        <button className="enter-menu-btn" onClick={handleEnterMenu}>
          <span>Enter Menu</span>
          <FaArrowRight className="arrow-icon" />
        </button>
        <p className="qr-footer">Or click to enter menu directly</p>
      </div>
    </div>
  );
}

export default QRLanding;

